module.exports = __webpack_public_path__ + "static/media/manual_usuario_pqr.a524b8b1.pdf";